<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import Error from '@/components/Error.vue';
import { useWarehouseInfo } from '@/composables/useWarehouseInfo';
import { CheckoutFlowStep, useCheckoutFlow } from '@/composables/useCheckoutFlow';
import { useCountdown } from '@/composables/useCountdown';

const { warehouseData } = useWarehouseInfo();
const { setNextStep } = useCheckoutFlow();
const router = useRouter();

const handleFinalizeCheckout = () => {
  setNextStep(CheckoutFlowStep.WelcomePage);
  router.push({
    name: 'checkout-flow',
    query: { warehouseId: warehouseData.value?.id }
  });
};

const { initializeTimer, stopTimer, secondsRemaining } = useCountdown(15, handleFinalizeCheckout);

onMounted(() => {
  initializeTimer();
});

onUnmounted(() => {
  stopTimer();
});
</script>

<template>
  <div class="fill-height d-flex flex-column gap-6 pt-4">
    <div class="d-flex flex-column gap-4 mt-6 px-4 flex-grow-1">
      <error
        :icon="'mdi-alert-circle'"
        :title="'Error loading BOL'"
        :message="warehouseData.settings?.checkoutBolNotLoadingErrorMessage as string" />

      <div class="pa-4">
        <v-btn block color="primary" @click="handleFinalizeCheckout">
          Finalize ({{ secondsRemaining }})
        </v-btn>
      </div>
    </div>
  </div>
</template>
